const GOLD_STRONG = 'rgba(200,146,42,.14)'
const GOLD_SOFT = 'rgba(200,146,42,.10)'

function Bar({ className = '', strong = false }) {
  return <div className={`rounded ${className}`} style={{ background: strong ? GOLD_STRONG : GOLD_SOFT }} />
}

export default function AstrologerDetailsSkeleton() {
  return (
    <div className="animate-pulse">
      {/* Breadcrumb */}
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 pt-6">
        <Bar className="h-3 w-52" />
      </div>

      {/* Profile hero */}
      <section className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-10">
        <div className="info-card p-6 sm:p-10">
          <div className="grid gap-10 grid-cols-1 lg:grid-cols-12 items-stretch">
            <div className="lg:col-span-4">
              <div className="rounded-[28px] min-h-[320px] h-full" style={{ background: GOLD_SOFT }} />
            </div>
            <div className="lg:col-span-8 space-y-5">
              <Bar className="h-8 w-2/3" strong />
              <Bar className="h-4 w-1/2" />
              <div className="flex flex-wrap gap-2">
                <Bar className="h-7 w-24 !rounded-full" />
                <Bar className="h-7 w-28 !rounded-full" />
                <Bar className="h-7 w-20 !rounded-full" />
              </div>
              <div className="space-y-2.5 pt-2">
                <Bar className="h-3 w-full" />
                <Bar className="h-3 w-11/12" />
                <Bar className="h-3 w-4/5" />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4">
                {Array.from({ length: 4 }, (_, i) => (
                  <div key={i} className="rounded-2xl h-20" style={{ background: GOLD_SOFT }} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content + booking sidebar */}
      <section className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 pb-16">
        <div className="grid gap-8 lg:grid-cols-[1fr_360px] items-start">
          <div className="space-y-8">
            {Array.from({ length: 3 }, (_, i) => (
              <div key={i} className="info-card p-6 sm:p-8 space-y-4">
                <Bar className="h-5 w-48" strong />
                <Bar className="h-3 w-full" />
                <Bar className="h-3 w-11/12" />
                <Bar className="h-3 w-3/4" />
              </div>
            ))}
          </div>
          <div className="info-card p-6 space-y-4">
            <Bar className="h-5 w-40" strong />
            <Bar className="h-12 w-full !rounded-2xl" />
            <Bar className="h-12 w-full !rounded-2xl" />
            <Bar className="h-3 w-2/3" />
            <Bar className="h-12 w-full !rounded-full" strong />
          </div>
        </div>
      </section>
    </div>
  )
}
